/*
----------------------------
Module - smp-search-filters
----------------------------
*/

import $ from 'jquery';

(function(){
    'use strict';

    squiz.fn.searchFilters = function() {

        function searchFilterChanged(event) {
            
            // Disable all filters so that user can't quickly select another bar filter option before the user is redirected
            $search_filters.prop("disabled", true);

            // Get the jQuery object of the filter that just changed
            var $search_filter = $(event.target);

            // Each select option value should contain the Funnelback toggle URL which actually contains the correct query string to redirect the user to a page that shows the correct filtered results
            var fb_toggle_query_string = $search_filter.val();

            if (fb_toggle_query_string.length) {
                
                window.location.href = fb_toggle_query_string;

            }

        }
        
        function setupSearchFilters() {

            // Filters are initially disabled by HTML markup to prevent users from interacting with it until script has loaded.
            // Now we can enable it
            $search_filters = $search_filters_wrapper.find("[type='radio'], [type='checkbox']");
            $search_filters.prop("disabled", false);

            $search_filters.on("change", searchFilterChanged)

        }

        function searchFilterToggleClicked(event) {

            var $this_search_filter_toggle = $(event.target);

            var expanded_status = $this_search_filter_toggle.attr("aria-expanded");
            var controlled_panel_id = $this_search_filter_toggle.attr("aria-controls");
            var $controlled_panel = $search_filters_wrapper.find("#" + controlled_panel_id);

            if (expanded_status === "false") {

                // Open the panel
                $this_search_filter_toggle.attr("aria-expanded", true);
                $controlled_panel.addClass(panel_expanded_class);

            } else {

                // Close the panel
                $this_search_filter_toggle.attr("aria-expanded", false);
                $controlled_panel.removeClass(panel_expanded_class);

            }

        }

        function setupSearchFiltersAccordions() {

            var $search_filters_toggles = $search_filters_wrapper.find(".search-filter-toggle");

            $search_filters_toggles.on("click", searchFilterToggleClicked);

        }

        function init() {

            $search_filters_wrapper = $(".smp-search-filters");

            if ($search_filters_wrapper.length) {

                setupSearchFiltersAccordions();
                setupSearchFilters();

            }

        }

        var $search_filters_wrapper;
        var $search_filters;
        var panel_expanded_class = "search-filter-panel--expanded";

        return {
            init: init
        }

    }();
        
    document.addEventListener("DOMContentLoaded", function () {
        squiz.fn.searchFilters.init();
    });

}());
